import React, { useEffect, useRef, useState } from "react";
import "./QuizTestLayout.css";
import { genTaskApi } from "../../../api/genTaskApi";
import { useLocation, useNavigate } from "react-router-dom";
import AlertMessage from "../../../components/common/AlertMessage";

export default function ExamDetail() {
  const [questionsData, setQuestionsData] = useState([]);
  const { state } = useLocation();
  const [alert, setAlert] = useState({ type: "", message: "" });
  const [answers, setAnswers] = useState({});

  // use a ref array; assign elements via ref callback in render
  const refs = useRef([]);
  const naviation = useNavigate();

  const shuffleChoices = (arr) => {
    const result = [...arr];
    for (let i = result.length - 1; i > 0; i -= 1) {
      const j = Math.floor(Math.random() * (i + 1));
      [result[i], result[j]] = [result[j], result[i]];
    }
    return result;
  };

  // functional update to avoid stale state
  const chooseAnswer = (qId, choiceIdx) => {
    setAnswers((prev) => ({ ...prev, [qId]: choiceIdx }));
  };

  const scrollToQuestion = (index) => {
    const el = refs.current[index];
    el?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  useEffect(() => {
    if (!state?.taskId) return;
    fetchTaskDetails(state.taskId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state?.taskId]);

  const fetchTaskDetails = async (taskId) => {
    try {
      const res = await genTaskApi.taskDetail(taskId);
      if (res?.success) {
        const datas = (res.data || []).map((x, idx) => ({
          // prefer stable id from backend if available
          id: x.questionId ?? idx + 1,
          text: x.text ?? "",
          choices: shuffleChoices(Array.isArray(x.choice) ? x.choice : []),
          answer: null,
          questionId: x.questionId,
          taskId: x.taskId,
        }));
        setQuestionsData(datas);
        // reset answers and refs when new data arrives
        setAnswers({});
        refs.current = [];
      }
    } catch (err) {
      // optionally handle/log error
    }
  };
  const handleOnSubmit = async () => {
    var param = {
      "taskId": state.taskId
    }
    const subParam = []
    questionsData.forEach(item => {
      const keyq = item.questionId;
      const valueIndex = answers[item.id];
      const value = item.choices[valueIndex];
      subParam.push({
        QuestionId: keyq,
        Value: value
      });
    });
    param.questionFieldValues = subParam;
    await genTaskApi.submit(param);
    setAlert({type: "success", message:"submit success"});
    naviation("/exam/category");
  }
  return (
    <div className="container mt-4">
      <AlertMessage message={alert.type} onClose={()=> setAlert({type :"", message: ""})}
      />
      <div className="row">
        {/* LEFT – scroll content */}
        <div className="col-md-8">
          <div className="quiz-scroll">
            {questionsData.map((q, idx) => (
              <div
                className="q-item"
                key={q.id}
                ref={(el) => {
                  refs.current[idx] = el;
                }}
              >
                <h5 className="fw-bold">
                  {idx + 1}. {q.text}
                </h5>

                {q.choices.map((c, i) => (
                  <div
                    key={i}
                    className={`p-2 mb-2 border rounded ${answers[q.id] === i ? "bg-primary text-white" : ""
                      }`}
                    style={{ cursor: "pointer" }}
                    onClick={() => chooseAnswer(q.id, i)}
                  >
                    {c}
                  </div>
                ))}
              </div>
            ))}
          </div>
          <button className="btn btn-danger finish-btn" onClick={handleOnSubmit}>Submit</button>
        </div>

        {/* RIGHT – STATUS BOX */}
        <div className="col-md-4">
          <div className="card shadow-sm p-3">
            <h6 className="fw-bold mb-3">Question state</h6>

            <div className="row g-2">
              {questionsData.map((x, idx) => {
                const stateClass = answers[x.id] !== undefined ? "done" : "none";
                return (
                  <div className="col-4" key={x.id}>
                    <div
                      className={`q-status-box ${stateClass === "done" ? "bg-success text-white" : "bg-light"
                        }`}
                      onClick={() => scrollToQuestion(idx)}
                    >
                      {idx + 1}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
